import React from 'react';
import { Link } from 'react-router-dom';

const PrivacyPage = () => {
  return (
    <div 
      className="min-h-screen px-6 py-12"
      style={{ background: '#F5EFE6' }}
      data-testid="privacy-page"
    >
      <div className="w-full max-w-3xl mx-auto">
        <Link 
          to="/" 
          className="inline-flex items-center text-sm mb-8 hover:opacity-70 transition-opacity"
          style={{ color: '#1A4D2E' }}
          data-testid="back-link"
        >
          &larr; Terug naar home
        </Link>

        <h1 
          className="text-2xl sm:text-3xl font-bold mb-2"
          style={{ color: '#1A4D2E' }}
        >
          Privacybeleid
        </h1>
        <p className="text-sm mb-8" style={{ color: '#1A4D2E', opacity: 0.6 }}>
          Laatst bijgewerkt: 13 april 2026
        </p>

        <div className="space-y-6 text-sm leading-relaxed" style={{ color: '#1A4D2E' }}>
          <section>
            <h2 className="text-lg font-semibold mb-2">1. Verwerkingsverantwoordelijke</h2>
            <p>
              TalentFixr, gevestigd in België, is verantwoordelijk voor de verwerking van 
              persoonsgegevens zoals beschreven in dit privacybeleid. Voor vragen over dit 
              beleid kan u ons bereiken via het e-mailadres vermeld op onze website.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold mb-2">2. Welke gegevens verzamelen wij?</h2>
            <p>Wij verzamelen de volgende persoonsgegevens wanneer u zich registreert op ons platform:</p>
            <ul className="list-disc pl-5 mt-2 space-y-1">
              <li>Voornaam</li>
              <li>E-mailadres</li>
              <li>Telefoonnummer</li>
              <li>Gewenste functie en ervaring</li>
              <li>Gewenste regio en industrie</li>
              <li>Gewenst loon</li>
              <li>Contractvoorkeur en zoekstatus</li>
            </ul>
          </section>

          <section>
            <h2 className="text-lg font-semibold mb-2">3. Rechtsgrond voor verwerking</h2>
            <p>
              Wij verwerken uw persoonsgegevens op basis van uw uitdrukkelijke toestemming 
              (artikel 6, lid 1, punt a) van de Algemene Verordening Gegevensbescherming (AVG/GDPR)). 
              U geeft deze toestemming bij het aanmaken van uw profiel door het aanvinken van het 
              toestemmingsvakje.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold mb-2">4. Doeleinden van de verwerking</h2>
            <p>Uw gegevens worden verwerkt voor de volgende doeleinden:</p>
            <ul className="list-disc pl-5 mt-2 space-y-1">
              <li>Het matchen van kandidaten met relevante vacatures</li>
              <li>Het aanmaken en beheren van uw gebruikersprofiel</li>
              <li>Het contacteren van u in verband met passende jobkansen</li>
              <li>Het verbeteren van onze dienstverlening en platform</li>
            </ul>
          </section>

          <section>
            <h2 className="text-lg font-semibold mb-2">5. Bewaartermijn</h2>
            <p>
              Uw persoonsgegevens worden bewaard zolang uw account actief is of zolang nodig 
              om u onze diensten te verlenen. U kunt op elk moment verzoeken om verwijdering 
              van uw gegevens. Na verwijdering worden uw gegevens binnen 30 dagen definitief 
              gewist uit onze systemen.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold mb-2">6. Delen met derden</h2>
            <p>
              Uw persoonsgegevens worden niet verkocht aan derden. Wij delen uw gegevens 
              uitsluitend met:
            </p>
            <ul className="list-disc pl-5 mt-2 space-y-1">
              <li>Potentiele werkgevers waarmee wij u matchen (enkel na uw toestemming)</li>
              <li>Technische dienstverleners die ons helpen het platform te beheren (verwerkers), gebonden door verwerkersovereenkomsten</li>
            </ul>
          </section>

          <section>
            <h2 className="text-lg font-semibold mb-2">7. Uw rechten onder de GDPR</h2>
            <p>Conform de AVG/GDPR heeft u de volgende rechten:</p>
            <ul className="list-disc pl-5 mt-2 space-y-1">
              <li><strong>Recht op inzage</strong> - U kunt opvragen welke gegevens wij van u bewaren</li>
              <li><strong>Recht op rectificatie</strong> - U kunt onjuiste gegevens laten corrigeren</li>
              <li><strong>Recht op gegevenswissing</strong> - U kunt verzoeken om verwijdering van uw gegevens</li>
              <li><strong>Recht op beperking</strong> - U kunt de verwerking laten beperken</li>
              <li><strong>Recht op overdraagbaarheid</strong> - U kunt uw gegevens in een gestructureerd formaat ontvangen</li>
              <li><strong>Recht van bezwaar</strong> - U kunt bezwaar maken tegen de verwerking</li>
              <li><strong>Recht om toestemming in te trekken</strong> - U kunt uw toestemming op elk moment intrekken</li>
            </ul>
            <p className="mt-2">
              Om een van deze rechten uit te oefenen, neem contact met ons op via het 
              e-mailadres vermeld op onze website.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold mb-2">8. Beveiliging</h2>
            <p>
              Wij nemen passende technische en organisatorische maatregelen om uw persoonsgegevens 
              te beschermen tegen ongeoorloofde toegang, verlies of misbruik. Dit omvat 
              versleutelde verbindingen (SSL/TLS), beveiligde servers en beperkte toegangsrechten.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold mb-2">9. Cookies en analytics</h2>
            <p>
              Wij gebruiken functionele cookies en analytische tools om het gebruik van ons 
              platform te begrijpen en te verbeteren. Analytische gegevens worden geanonimiseerd 
              verwerkt. U kunt cookies beheren via uw browserinstellingen.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold mb-2">10. Klachten</h2>
            <p>
              Indien u een klacht heeft over de verwerking van uw persoonsgegevens, kunt u 
              contact met ons opnemen. U heeft ook het recht om een klacht in te dienen bij 
              de Gegevensbeschermingsautoriteit (GBA):
            </p>
            <p className="mt-2">
              Gegevensbeschermingsautoriteit<br />
              Drukpersstraat 35, 1000 Brussel<br />
              Tel: +32 (0)2 274 48 00<br />
              E-mail: contact@apd-gba.be<br />
              Website: www.gegevensbeschermingsautoriteit.be
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold mb-2">11. Wijzigingen</h2>
            <p>
              Wij behouden ons het recht voor om dit privacybeleid te wijzigen. Significante 
              wijzigingen worden aan u gecommuniceerd via het platform of per e-mail. De 
              meest recente versie is altijd beschikbaar op deze pagina.
            </p>
          </section>
        </div>

        <div className="mt-12 pt-6 border-t" style={{ borderColor: 'rgba(26, 77, 46, 0.15)' }}>
          <p className="text-xs" style={{ color: '#1A4D2E', opacity: 0.5 }}>
            &copy; 2026 TalentFixr. Alle rechten voorbehouden.
          </p>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPage;
